<template>
  <div>
    <el-dialog
      title="等待"
      :close-on-click-modal="false"
      :visible.sync="viewVisible"
      @click="viewVisible = false"
    >
      <el-form
        label-position="left"
        :model="awaitForm"
        :rules="rules"
        :disabled="isReadOnly"
        ref="ruleForm"
        :label-width="formLabelWidth"
      >
        <el-form-item label="节点名称" prop="name">
          <el-input
            v-model="awaitForm.name"
            autocomplete="off"
            show-word-limit
            :maxlength="20"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="等待时间">
          <div class="lineBox">
             <el-date-picker
              v-model="awaitForm.waitDateTime"
              :editable="false"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              :picker-options="pickerOptions"
              :default-time="defaultTime"
              @change="datetimeChage"
              @focus="getDefaultTime"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <!-- <div> -->
         <!-- <div style="width:900px;line-height:22px;color:red;margin-top:-16px;margin-bottom:4px">
          <div>注意：</div>
          <div>（1）618大促期间短信发送时间：5月30日-6月15日为8:00-22:00，6月16日-6月17日为8:00-次日01:00，6月18日为00:00-23:59:59，6月19日起恢复正常（即9:00-20:00）。</div>
          <div>（2）5月31日-6月18日京东官方短信频控规则:同一商家2天内给同一手机号发送营销短信条数不超过 1 条;每个手机号每 1 天只能收到 9条京东商家短信,每 2 天只能收到 16条京东商家短信。</div>
          </div>
        </div> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="isReadOnly" @click="awaitSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mnode from "@/api/intelligentMarket/a_node";
import {
  getSendTime,
} from "@/api/smsSend";
export default {
  name: "awaitDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    nodeId: Number,
    marketingId: Number,
    'isReadOnly': {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'awaitForm.waitDateTime': {
      handler(newValue, oldValue) {
        if ((newValue && oldValue && (newValue.substring(0, 10) != oldValue.substring(0, 10))) || (newValue && !oldValue)) {
          if (this.isEdit) {
            this.isEdit = false;
            return;
          }
          var val = newValue.substring(0, 10)
          var nowTime10 = this.$getNowDate();
          var time1 = nowTime10.substring(0, 10);
          var time2 = nowTime10.substring(11, 19);
          var startTime = this.limitTime.startTime;
          var endTime = this.limitTime.endTime;
          // var time2 = "20:58:59";
          var arr = time2.split(":");
          var endArr = endTime.split(":");

          // 最晚可以选到时间
          if (arr[0] > endArr[0]) {
            time2 = endTime;
          } else if (arr[0] == endArr[0] && arr[1] > endArr[1]) {
            time2 = endTime;
          } else if (
            arr[0] == endArr[0] &&
            arr[1] == endArr[1] &&
            arr[2] >= endArr[2]
          ) {
            time2 = endTime;
          }

          if (val == time1) {
            this.awaitForm.waitDateTime = val + ' ' + time2;
            this.pickerOptions.selectableRange = time2 + " - " + endTime;
          } else {
            // this.awaitForm.waitDateTime = val + ' ' + startTime;
            this.pickerOptions.selectableRange = startTime + " - " + endTime;
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.limitSendTime();
    mnode.getNode({ nodeId: this.nodeId }).then(res => {
      if (res.code === 1 && res.data.name) {
        let formData
        if (res.code ==1) {
          formData = res.data;
          // formData.name = res.data.name;
          // this.awaitForm = formData
          this.awaitForm.name= res.data.name;
          this.isEdit = true;
          this.awaitForm.waitDateTime = res.data.waitTime;
          this.awaitForm.nodeId = res.data.nodeId
        } else {
          this.awaitForm.name = res.data.name
        }
      }
    })
  },
  data() {
    return {
      // visible: true,
      defaultTime: "",
      formLabelWidth: "80px",
      rules: {
        name: [
          { required: true, message: "请输入节点名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      awaitForm: {
        name: "",
        waitType: "0",
        waitDateTime: "",
        waitDays: "",
        waitHourAndMinutes: "00:00",
        waitHours: "",
        waitMinutes: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date().getTime() - 24 * 60 * 60 * 1000 || time.getTime() > Date.now() + 8.64e7 * 90;
        },
        selectableRange: "9:00:00 - 19:55:59",
      },
      limitTime: {},
      isEdit: false, // 是否编辑回显
    };
  },
  computed: {
    viewVisible: {
      get: function() {
        return this.visible
      },
      set: function(newValue) {
        if (newValue) {
          this.$emit('update:visible', true)
        } else {
          this.$emit('update:visible', false)
        }
      }
    }
  },
  methods: {
    limitSendTime() {
      getSendTime().then((res) => {
        this.limitTime = res.data;
        var selectableRange = res.data.startTime + " - " + res.data.endTime;
        this.pickerOptions.selectableRange = selectableRange;
      });
    },

    awaitSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let formData = this.getDataify();
          let wait = {}
          wait.name = formData.name;
          wait.waitTime = formData.waitNode.waitDateTime;
          wait.nodeId = formData.waitNode.nodeId;
          if (wait) {
            mnode.updateDetail(wait).then(res => {
              if (res.code === 1) {
                this.$message.success(res.message);
                this.viewVisible = false;
                this.$emit('change-name', wait);
              }
            })
          }
        } else {
          return false
        }
      })
    },
    handleClose() {},
    getDataify () {
      let formData = {}
      let now = new Date()
      let time = now.getTime()
      let setTime
      if (this.awaitForm.waitType === '0') {
        if (!this.awaitForm.waitDateTime) {
          this.$message.error('请选择等待指定时间！')
          return false
        } else {
          setTime = new Date(this.awaitForm.waitDateTime).getTime() - time
        }
      }
      if (this.awaitForm.waitType === '1') {
        if (!this.awaitForm.waitDays) {
          this.$message.error('请填写等待天数！')
          return false
        } else if (!new RegExp('^\\d{0,2}$|^100$', 'g').test(this.awaitForm.waitDays)) {
          this.$message.error('等待天数为2位数以内整数！')
          return false
        } else if (!this.awaitForm.waitHourAndMinutes) {
          this.$message.error('请选择等待时间！')
          return false
        } else {
          setTime = parseInt(this.awaitForm.waitDays) * 86400000
          if (this.awaitForm.waitHourAndMinutes) {
            let relativeStartTimes = this.awaitForm.waitHourAndMinutes.split(':')
            setTime = setTime + parseInt(relativeStartTimes[0]) * 3600000 + parseInt(relativeStartTimes[1]) * 60000
          }
        }
      }
      if (this.awaitForm.waitType === '2') {
        if (!this.awaitForm.waitHours) {
          this.$message.error('请填写等待小时数！')
          return false
        } else if (!new RegExp('^\\d{0,3}$', 'g').test(this.awaitForm.waitHours)) {
          this.$message.error('等待小时数为3位数以内整数！')
          return false
        } else if (!this.awaitForm.waitMinutes) {
          this.$message.error('请填写等待分钟数！')
          return false
        } else if (!new RegExp('^\\d{0,3}$', 'g').test(this.awaitForm.waitMinutes)) {
          this.$message.error('等待分钟数为3位数以内整数！')
          return false
        } else {
          setTime = parseInt(this.awaitForm.waitHours) * 3600000 + parseInt(this.awaitForm.waitMinutes) * 60000
        }
      }
      if (setTime < 1800000) {
        this.$message.error('等待时间要大于当前时间30分钟！')
        return false
      }
      formData.smartMarketingNodeId = this.$props.nodeId
      formData.name = this.awaitForm.name
      formData.waitNode = JSON.parse(JSON.stringify(this.awaitForm, (key, value) => {
        if (key === 'name') {
          return undefined
        }
        return value
      }))
      return formData
    },
    datetimeChage(dateTime) {
      if (this.awaitForm.waitType === "0") {
        let now = new Date().getTime();
        let setTime = new Date(dateTime).getTime();
        setTime - now < 1800000 &&
          this.$message.error("等待时间要大于当前时间30分钟！");
      }
    },

    getDefaultTime() {
      let now = new Date().getTime();
      now = now + 31 * 60000;
      now = new Date(now);
      this.defaultTime = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
    },
    eventTimeChage (time) {
      if (this.awaitForm.waitType === '1' && (this.awaitForm.waitDays === '0' || !this.awaitForm.waitDays)) {
        let relativeStartTimes = time.split(':')
        if (!(relativeStartTimes[0] > 0)) {
          let setTime = parseInt(relativeStartTimes[1]) * 60000
          setTime < 1800000 && this.$message.error('等待时间要大于当前时间30分钟！')
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>